import { createSlice } from '@reduxjs/toolkit';
const initialState = false;
const logoutButtonSlice = createSlice({
    name: 'logoutButton',
    initialState,
    reducers: {
        showDisplayAction(state) {
            return state = true;
        },
        hideDisplayAction(state) {
            return state = false;
        }
    },
});
//Actions
export const { showDisplayAction, hideDisplayAction } = logoutButtonSlice.actions;
export default logoutButtonSlice;
